// extracted by mini-css-extract-plugin
export default {"order__image":"image-container_order__image__ol1J8","text":"image-container_text__dpAtF"};